<div class="container">
    <div class="row">
        <!-- Sidebar for categories -->
        <div class="col-md-3 mt-5">
            <div class="navbar navbar-expand-lg navbar-light">
                <!-- Toggler Button for Mobile -->
                <button class="navbar-toggler" type="button" (click)="toggleSidebar()">
                    <span class="navbar-toggler-icon"></span>
                </button>

                <!-- Sidebar (for mobile) -->
                <div *ngIf="isSidebarVisible" class="sidebar p-3 bg-light rounded shadow-sm no-pointer">
                   
                    <ul class="list-group">
                        <li class="list-group-item list-group-item-action" *ngFor="let category of categories"
                            (click)="filterProductsByCategory(category.name)"
                            [class.active]="category.name === selectedCategory">
                            <h3 style="pointer-events: none;">{{category.name}}</h3>
                        </li>
                    </ul>
                </div>

                <!-- Category list in Navbar for Large Screens -->
                <div class="navbar-collapse collapse navbar-nav ml-auto d-none d-lg-flex" *ngIf="!isSidebarVisible"
                    style="background-color: white;border: none;">
                    <div class="sidebar p-3 rounded shadow-sm no-pointer" style="background-color: white;">
                        
                        <ul class="list-group" style="border: none;">
                            <li class="list-group-item list-group-item-action" style="border: none;"
                                *ngFor="let category of categories" (click)="filterProductsByCategory(category.name)"
                                [class.active]="category.name === selectedCategory">
                                <h3 style="pointer-events: none;">{{category.name}}</h3>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>


            <!--div class="sidebar p-3 bg-light rounded shadow-sm no-pointer">
                <h3 class="text-primary">Categories</h3>
                <ul class="list-group">
                    <li class="list-group-item list-group-item-action"  
                        *ngFor="let category of categories" 
                        (click)="filterProductsByCategory(category.name)"
                        [class.active]="category.name === selectedCategory">
                        
                        <h3 style="pointer-events: none;">{{category.name}}</h3>  
                    </li>
                </ul>
            </div-->
        </div>

        <!-- Products Section -->
        <div class="col-md-9">
            <div class="section-title" *ngFor="let Content of sectionTitle;">
                <!--h2 class="text-center text-uppercase font-weight-bold">{{Content.title}}</h2-->
            </div>

            <div class="products-list">
                <div class="row">
                    <div class="col-md-4" *ngFor="let Content of paginatedProducts">
                        <div class="single-products-item border rounded p-3 shadow-sm">
                            <div class="products-image">
                                <a routerLink="/admin/simple-product-edit/{{Content.keywords}}" class="d-block">
                                    <img [src]="Content.mainImg" alt="image" class="img-fluid rounded">
                                </a>
                                <ul class="products-button list-unstyled d-flex justify-content-center mt-2">
                                    <li class="mx-2"><a routerLink="/admin/simple-product-edit/{{Content.keywords}}"><i
                                                class='bx bx-show-alt'></i></a></li>
                                    <li class="mx-2"><a href="{{Content.mainImg}}" class="popup-btn"><i
                                                class='bx bx-scan'></i></a></li>
                                    <li class="mx-2"><a routerLink="/admin/simple-product-edit/{{Content.keywords}}"><i
                                                class='bx bx-link'></i></a></li>
                                </ul>
                            </div>
                            <div class="products-content text-center">
                                <h3><a routerLink="/admin/simple-product-edit/{{Content.keywords}}">{{Content.title}}</a></h3>
                                <div class="price">
                                    <span class="new-price text-success font-weight-bold">{{Content.newPrice}}</span>
                                    <span class="old-price text-danger text-decoration-line-through"
                                        *ngIf="Content.oldPrice">{{Content.oldPrice}}</span>
                                </div>
                            </div>
                            <span class="badge badge-warning" *ngIf="Content.sale">{{Content.sale}}</span>
                            <div class="text-danger font-weight-bold" *ngIf="Content.outOfStock">{{Content.outOfStock}}
                            </div>
                            <div class="d-flex justify-content-between mt-2">
                                <div class="form-check mt-2">
                                    <input class="form-check-input" type="checkbox"
                                        (click)="checkBoxStatusClicked(Content.id,Content.status === 'NEW')"
                                        [checked]="Content.status === 'NEW'">
                                    <label class="form-check-label ">
                                        New
                                    </label>
                                </div>
                                <div class="form-check mt-2">
                                    <input class="form-check-input" type="checkbox" [checked]="Content.inhomeBanner" style="color:red;"
                                        (click)="checkBoxInHomeBannerClicked(Content.id,!Content.inhomeBanner)">
                                    <label class="form-check-label">
                                        In home banner
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="pagination d-flex justify-content-center mt-4">
                <button class="btn btn-primary mx-2" (click)="previousPage()"
                    [disabled]="currentPage === 1">Previous</button>
                <span class="align-self-center font-weight-bold">Page {{currentPage}} of {{totalPages}}</span>
                <button class="btn btn-primary mx-2" (click)="nextPage()"
                    [disabled]="currentPage === totalPages">Next</button>
            </div>
        </div>


    </div>
</div>

<!--div class="container">
    <div class="section-title" *ngFor="let Content of sectionTitle;">
        <h2>{{Content.title}}</h2>
       
    </div>

    <div class="products-slides">
        <owl-carousel-o [options]="productsSlidesOptions">
            <ng-template carouselSlide *ngFor="let Content of singleProductsItem;">
                <div class="single-products-item">
                    <div class="products-image">
                        <a routerLink="/admin/simple-product-edit/{{Content.id}}" class="d-block">
                            <img [src]="Content.mainImg" alt="image">
                        </a>
                        <ul class="products-button">
                            
                            <li><a routerLink="/admin/simple-product-edit/{{Content.id}}"><i class='bx bx-show-alt'></i></a></li>
                            <li><a href="{{Content.mainImg}}" class="popup-btn"><i class='bx bx-scan'></i></a></li>
                            <li><a routerLink="/admin/simple-product-edit/{{Content.id}}"><i class='bx bx-link'></i></a></li>
                        </ul>
                       
                    </div>
                    <div class="products-content">
                        <h3><a routerLink="/admin/simple-product-edit/{{Content.id}}">{{Content.title}}</a></h3>
                        <div class="price">
                            <span class="new-price">{{Content.newPrice}}</span>
                            <span class="old-price" *ngIf="Content.oldPrice">{{Content.oldPrice}}</span>
                        </div>
                    </div>
                    <span class="on-sale" *ngIf="Content.sale">{{Content.sale}}</span>
                    <div class="out-of-stock" *ngIf="Content.outOfStock">{{Content.outOfStock}}</div>
                </div>
            </ng-template>
        </owl-carousel-o>
    </div>
</div-->